export const translations = {
  cancelButton: {
    pt: 'Cancelar',
    en: 'Cancel',
    es: 'Cancelar',
    de: 'Abbrechen',
  },
  submitButton: {
    pt: 'Salvar',
    en: 'Save',
    es: 'Guardar',
    de: 'Speichern',
  },
}